import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { FilterOption } from 'Components/widgets/filter-option/FilterOption';
type Props = {
  className?: string;
  name: string;
  onChange: (value: string) => void;
  options: Array<FilterOptionProps>;
};
export const FilterOptions = ({ className, name, onChange, options = [] }: Props) => {
  const { isTablet } = useResponsive();
  return (
    <ul className={classnames('-m-5 sm:flex sm:flex-wrap', className)}>
      {options.map((option) => (
        <li className="p-5 sm:w-1/4 md:w-1/6" key={option.id}>
          <FilterOption
            {...option}
            className={isTablet ? 'h-full w-full text-black shadow-diffuse' : ''}
            isButton={isTablet}
            name={name}
            onChange={onChange}
          />
        </li>
      ))}
    </ul>
  );
};
